import styled from 'styled-components';

export const InventoryGrid = styled.div`
  display: flex;
  justify-content: start;
  gap: 10rem;
  padding: 20px;
`;

export const Shelf = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  height: 400px;
`;

export const ShelfLabel = styled.div`
  font-size: 20px;
  margin-bottom: 10px;
`;

export const BoxRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  padding: 10px 0;
  background-color: white; /* Background color inside the border */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Depth effect */
  padding: 5px;
`;

export const BoxContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Label = styled.div`
  margin-top: 5px;
  font-size: 14px;
`;

export const Border = styled.div`
  width: 100%;
  height: 5px;
  background-color: #495057;
`;

export const ShelfEndBorder = styled.div`
  width: 100%;
  height: 30px; /* Adjust height as needed */
  background-color: #495057;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: 10px; */
  position: relative;
`;

export const ShelfEndInnerBorder = styled.div`
  width: 100%;
  height: 20px; /* Adjust height as needed */
  background-color: #ffffff;
  border-bottom: 10px solid #495057; /* Top black border */
  box-sizing: border-box;
  position: relative;
`;

export const VerticalLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 5px; /* Adjust width as needed */
  background-color: #495057;
`;

export const LeftVerticalLine = styled(VerticalLine)`
  left: 40%; /* Adjust position as needed */
`;

export const RightVerticalLine = styled(VerticalLine)`
  right: 40%; /* Adjust position as needed */
`;

export const CompartmentName = styled.div`
  margin-right: 10px;
  font-size: 14px;
  font-weight: bold;
  flex: 0 0 auto; /* Take only necessary space */
`;
